<template>
  <div name="logical-statement-add-list" class="addlist-wrapper clearfix">
    <div v-if="listDisp">
      <div v-if="!rootNode && addConjDisp" class="list-box clearfix">
        <div class="pull-left" style="font-weight: bold;">Conjunction</div>
        <i class="fa fa-close close-button" @click="deleteAddConjDisp(false)" title="click for cancel adding conjunction"/>
        <select v-model="newObjConj.conj"
                v-validate="'required'" data-vv-name="listConjunction"
                class="select-input-1"
                :class="{ 'input-error' : errors.has('listConjunction') }">
          <option v-for="(val, key) in listConjunctions" :value="key">{{ val }}</option>
        </select>
        <span v-show="errors.has('listConjunction')" class="validate-text">{{ errors.first('listConjunction') }}</span>
      </div>
      <div v-if="addStmtDisp" class="list-box clearfix">
        <div class="pull-left" style="font-weight: bold;">Statement</div>
        <i class="fa fa-close close-button" @click="deleteAddStmtDisp(false)" title="click for cancel adding statement"/>
        <select v-model="newList.field"
                v-validate="'required'" data-vv-name="listField"
                class="select-input-1"
                :class="{ 'input-error' : errors.has('listField') }">
          <option v-for="listField in listFields" :value="listField.code">{{ listField.description }}</option>
        </select>
        <span v-show="errors.has('listField')" class="validate-text">{{ errors.first('listField') }}</span>
        <select v-model="newList.operator"
                v-validate="'required'" data-vv-name="listOperator"
                class="select-input-2"
                :class="{ 'input-error' : errors.has('listOperator') }">
          <option v-for="listOperator in listOperators" v-if="listOperator.type.indexOf(findValueType(newList.field)) > -1" :value="listOperator.code">{{ listOperator.description }}</option>
        </select>
        <span v-show="errors.has('listOperator')" class="validate-text">{{ errors.first('listOperator') }}</span>
        <higher-order-value-component 
                      :newListFieldBool="newListFieldBool"
                      :nowLang="nowLang"
                      :labelCodsex="labelCodsex"
                      :listField="newList.field"
                      v-model="newList.value"
                      :findValueType="findValueType"
                      :findInputType="findInputType"
                      :findLovType="findLovType"
                      v-validate="'required'"
                      data-vv-value-path="listValue"
                      data-vv-as="listValue"
                      data-vv-name="listValue"
                      name="listValue"
        />
        <span v-show="errors.has('listValue')" class="validate-text">{{ errors.first('listValue') }}</span>
      </div>
    </div>

    <div class="validate-box" style="margin-left:15px;" >
      <span v-show="!validStmt" class="validate-text">Valid Statement: {{validStmt}}</span>
    </div>

    <div class="logical-button bg-dark-gray" v-show="listDisp" @click="triggerBack()">
      <i class="fa fa-times-circle" aria-hidden="true"></i>Cancel
    </div>
    <div class="logical-button bg-color-skin" v-show="listDisp" @click="triggerAddList(newList, newObjConj)">
      <i class="fa fa-plus-circle" aria-hidden="true"></i>Add</div>
    <div class="logical-button bg-dark-gray" v-show="!listDisp && totalLists > 0" @click="resetLists()">
      <i class="fa fa-refresh" aria-hidden="true"></i>Reset
    </div>
    <div class="logical-button bg-dark-gray -disable" v-show="!listDisp && totalLists === 0">
      <i class="fa fa-refresh" aria-hidden="true"></i>Reset
    </div>
    <div class="logical-button bg-dark-gray" v-show="!listDisp" @click="triggerShowAddList()">
      <i class="fa fa-plus-circle" aria-hidden="true"></i>{{ labelAddList }}
    </div>
    <div class="logical-button bg-color-skin" v-show="!listDisp && totalEdit === 0" data-dismiss="modal" @click="triggerSubmit()">
      <i class="fa fa-check-circle" aria-hidden="true"></i>Submit
    </div>
  </div>
</template>

<script>
  import higherOrderValueComponent from './higherOrderValueComponent'

  export default {
    name: 'logical-statement-add-list',
    data () {
      return {
        newList: this.list,
        newObjConj: this.objConj,
        addConjDisp: true,
        addStmtDisp: true
      }
    },
    watch: {
      list (newVal) {
        this.newList = newVal
      },
      objConj (newVal) {
        this.newObjConj = newVal
      }
    },
    computed: {
      labelAddList () {
        return (this.totalLists === 0) ? 'Add a list' : 'Add more'
      }
    },
    methods: {
      deleteAddConjDisp (addConjDisp) {
        this.addConjDisp = addConjDisp
        if ((!this.addConjDisp && !this.addStmtDisp) || (this.rootNode && !this.addStmtDisp)) {
          this.triggerBack()
        }
      },
      deleteAddStmtDisp (addStmtDisp) {
        this.addStmtDisp = addStmtDisp
        if ((!this.addConjDisp && !this.addStmtDisp) || (this.rootNode && !this.addStmtDisp)) {
          this.triggerBack()
        }
      },
      triggerBack () {
        this.addConjDisp = true
        this.addStmtDisp = true
        this.back()
      },
      triggerSubmit () {
        this.submit()
      },
      triggerAddList (newList, newObjConj) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.addList({ newList: newList, addStmtDisp: this.addStmtDisp }, { newObjConj: newObjConj, addConjDisp: this.addConjDisp })
            this.addConjDisp = true
            this.addStmtDisp = true
          }
        })
      },
      triggerShowAddList () {
        this.errors.clear()
        this.showAddList()
      }
    },
    props: {
      rootNode: {
        type: Boolean
      },
      totalLists: {
        type: Number
      },
      totalEdit: {
        type: Number
      },
      labelCodsex: {
        type: Object
      },
      nowLang: {
        type: String,
        default: 'th'
      },
      list: {
        type: Object,
        default () {
          return {
            field: '',
            operator: '',
            value: ''
          }
        }
      },
      listDisp: {
        type: Boolean,
        defaul: false
      },
      objConj: {
        type: Object,
        default: ''
      },
      listFields: {
        type: Array,
        required: true
      },
      listConjunctions: {
        type: Object,
        required: true
      },
      listOperators: {
        type: Array,
        required: true
      },
      addList: {
        type: Function
      },
      resetLists: {
        type: Function
      },
      back: {
        type: Function
      },
      submit: {
        type: Function
      },
      findValueType: {
        type: Function
      },
      findInputType: {
        type: Function
      },
      findLovType: {
        type: Function
      },
      showAddList: {
        type: Function
      },
      validStmt: {
        type: Boolean,
        default: true
      }
    },
    components: {
      higherOrderValueComponent
    }
  }
</script>


// WEBPACK FOOTER //
// addList.vue?fcbfe61a